import React from 'react';

interface UserInfoProps {
  label: string;
  value: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ label, value }) => {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:gap-4">
      <h3 className="text-sm text-black text-opacity-50 sm:w-32">{label}</h3>
      <p className="text-sm text-black ">{value}</p>
    </div>
  );
};

export default UserInfo;
